import * as React from "react";
import { BaseModal } from "../../../atoms/base-modal";
import classnames from "classnames";

interface ModalWithInputProps {
  isActive: boolean;
  isLoading: boolean;
  onModal: () => void;
  onSubmit: () => void;
  title: string;
  body: string;
  btnTitle: string;
}

export const ConfirmationModal: React.FunctionComponent<
  ModalWithInputProps
> = ({ isActive, isLoading, onModal, onSubmit, title, body, btnTitle }) => {
  return (
    <BaseModal isActive={isActive} title={title} onClose={onModal}>
      <section className="modal-card-body">
        <h2>{body}</h2>
      </section>
      <section className="modal-card-foot">
        <button
          type="button"
          className="button is-fullwidth is-failure"
          onClick={onModal}
        >
          キャンセルする
        </button>
        <button
          className={classnames("button is-info is-fullwidth", {
            "is-loading": isLoading,
          })}
          onClick={onSubmit}
        >
          {btnTitle}
        </button>
      </section>
    </BaseModal>
  );
};
